import { InverterSetupBase } from './InverterSetupBase'
import { InverterSetupMPPTracker } from './InverterSetupMPPTracker'

export class InverterSetup extends InverterSetupBase {
	mppTrackers: InverterSetupMPPTracker[] = [];

	updatePanelCount() {
		let total = 0;
		for (let tracker of this.mppTrackers) {
			total += tracker.stringCount * tracker.panelCount;
		}
		this.panelCount = total;
	}

}
